<template>
  <Container class="w-full">
    <div
      class="bg-gradient-black-01 my-12 flex w-full flex-col items-center justify-between rounded-3xl px-4 py-6 text-white md:p-12 lg:flex-row">
      <div class="flex items-center space-x-8">
        <h3 class="text-center text-3xl font-medium md:text-left">Want to share this article?</h3>
      </div>

      <BlogShareLinks class="mt-8 lg:mt-0" />
    </div>
  </Container>
</template>
